import { render, staticRenderFns } from "./HospitalOPDCardSettings.vue?vue&type=template&id=faddc470&scoped=true&"
import script from "./HospitalOPDCardSettings.vue?vue&type=script&lang=js&"
export * from "./HospitalOPDCardSettings.vue?vue&type=script&lang=js&"
import style0 from "./HospitalOPDCardSettings.vue?vue&type=style&index=0&id=faddc470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faddc470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faddc470')) {
      api.createRecord('faddc470', component.options)
    } else {
      api.reload('faddc470', component.options)
    }
    module.hot.accept("./HospitalOPDCardSettings.vue?vue&type=template&id=faddc470&scoped=true&", function () {
      api.rerender('faddc470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/HospitalOPDCardSettings.vue"
export default component.exports